/** @namespace Bodymod/Matomo/EventData/OrderItems/Data/parseOrderData */
export function parseOrderData(items) {
    const products = items.map((product) => {
        const {
            id, name, price, quantity, category
        } = product;

        return {
            id,
            name,
            category,
            price: +price,
            quantity
        };
    });

    return products;
}
